import "@/App.css";
import "@/styles/animations.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import CyberGuyPage from "@/pages/CyberGuyPage";
import VideoDetailPage from "@/pages/VideoDetailPage";
import InsightsPage from "@/pages/InsightsPage";
import ContactPage from "@/pages/ContactPage";
import HealthCheckPage from "@/pages/HealthCheckPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/:slug" element={<ServiceDetailPage />} />
          <Route path="/the-cyber-guy" element={<CyberGuyPage />} />
          <Route path="/the-cyber-guy/:slug" element={<VideoDetailPage />} />
          <Route path="/insights" element={<InsightsPage />} />
          <Route path="/insights/:id" element={<InsightsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/security-health-check" element={<HealthCheckPage />} />
          {/* Legacy paths redirect to their new homes */}
          <Route path="/training-catalog" element={<Navigate to="/services/security-awareness-training" replace />} />
          <Route path="/industry-solutions" element={<Navigate to="/services" replace />} />
          <Route path="/client-portal" element={<Navigate to="/contact" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
